import { Radio, Group } from "@mantine/core";

export const RadioButtonGroup = ({ name, label, data, value, onChange }) => (
  <Radio.Group
    name={name}
    label={label}
    withAsterisk
    value={value}
    onChange={onChange}
  >
    <Group mt="xs">
      {data.map((item) => (
        <Radio key={item.value} value={item.value} label={item.label} />
      ))}
    </Group>
  </Radio.Group>
);
